module.exports = __webpack_public_path__ + "static/agendamento-mobile-f978ecd404efac5674d091b3b214d5df.jpg";